import React from 'react';
import Button from 'app/components/button';

// Mirrors the regular Collect Voucher drawer (CollectionPanel/CollectVoucher.js):
// same off-canvas markup, disabled phone number, same field labels and buttons.
// Each voucher in the package adds its own code and serial pair, labelled with
// the voucher's title. Presentational only: lines, handlers and the open flag
// all come from usePackageCollect. Mount it as a page-level sibling, never
// inside another <form>.
export const PackageCollectPanel = ({
  lines = [],
  phoneNumber = '',
  isOpen,
  setIsOpen,
  onLineChange,
  onSubmit,
  heading = 'Collect Voucher',
  submitLabel = 'Submit',
}) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.target;
    if (form.checkValidity()) {
      onSubmit();
    } else {
      form.reportValidity();
    }
  };

  const handleCancel = () => {
    setIsOpen(false);
  };

  return (
    <div className={`offcanvas-modal ${isOpen ? 'open' : ''}`}>
      <div className='offcanvas-modal-content'>
        <div className='offcanvas-modal-header'>
          <h4>{heading}</h4>
          <button
            type='button'
            className='close-button'
            onClick={handleCancel}
          >
            ×
          </button>
        </div>

        <form className='offcanvas-modal-body' onSubmit={handleSubmit}>
          <div className='offcanvas-item'>
            <label htmlFor='collect-package-phone'>Phone Number:</label>
            <input
              id='collect-package-phone'
              type='number'
              value={phoneNumber}
              disabled
            />
          </div>

          {lines.map((line) => {
            const key = line.reserveVoucherId;
            return (
              <React.Fragment key={key}>
                <div
                  className='offcanvas-item'
                  data-testid={`collect-code-field-${key}`}
                >
                  <label htmlFor={`collect-code-${key}`}>
                    {line.voucherTitle} Collection Code :
                  </label>
                  <input
                    id={`collect-code-${key}`}
                    type='text'
                    required
                    value={line.voucherCode}
                    onChange={(e) =>
                      onLineChange(key, 'voucherCode', e.target.value)
                    }
                  />
                  {/* A <span>, as the other admin forms use: a <p> adds the
                      page's default 1rem bottom margin under every error. */}
                  {line.codeError && (
                    <span className='loginWrapper-valid-text'>
                      {line.codeError}
                    </span>
                  )}
                </div>
                <div
                  className='offcanvas-item'
                  data-testid={`collect-serial-field-${key}`}
                >
                  <label htmlFor={`collect-serial-${key}`}>
                    {line.voucherTitle} Serial Number:
                  </label>
                  <input
                    id={`collect-serial-${key}`}
                    type='text'
                    required
                    value={line.serialNumber}
                    onChange={(e) =>
                      onLineChange(key, 'serialNumber', e.target.value)
                    }
                  />
                  {line.serialError && (
                    <span className='loginWrapper-valid-text'>
                      {line.serialError}
                    </span>
                  )}
                </div>
              </React.Fragment>
            );
          })}

          <div className='offcanvas-actions'>
            <Button
              className='mt1'
              onClick={() => {}}
              variant='Save'
              name={submitLabel}
            />
            <Button
              className='mt-1 cancel-button'
              onClick={handleCancel}
              variant='Cancel'
              name='Cancel'
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default PackageCollectPanel;
